import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import TagTemplate from '@ui/Tag/Tag';
import moment from 'moment';
import { ROUTES } from '../../constants';
import { IAcademyItem } from '../../interfaces/Calendar';
import {
    Item,
    Tags,
    Topic,
    TopicDescription,
    TopicFirstRow,
    TopicSecondRow,
    TopicThirdRow,
    TopicTitle,
} from './AcademyProduct.elements';

export interface AcademyProductProps {
    event: IAcademyItem;
}

const AcademyProductTemplate: FC<AcademyProductProps> = ({ event }) => {
    const { t } = useTranslations();

    const router = useRouter();

    const buildRedirectPathname = () => `${ROUTES.ACADEMY_DETAIL}/${event.module?.slug}`;

    return (
        <Item>
            <Topic>
                <TopicFirstRow>
                    {moment(event?.date_from).format('MM/YYYY')} - {moment(event?.date_to).format('MM/YYYY')}
                </TopicFirstRow>
                <TopicSecondRow>
                    <TopicTitle onClick={() => router.push(buildRedirectPathname())}>{event?.module?.name}</TopicTitle>
                    <TopicDescription dangerouslySetInnerHTML={{ __html: event?.module?.annotation }} />
                </TopicSecondRow>
                <>
                    <TopicThirdRow>
                        <Tags>
                            {event?.tags?.map((tag: { color: string; title: string }, key: number) => (
                                <TagTemplate key={`tag-${key}`} name={tag.title} color={tag.color} />
                            ))}
                        </Tags>
                        <ButtonTemplate
                            marginTop={10}
                            onClick={() =>
                                router.push({
                                    pathname: buildRedirectPathname(),
                                })
                            }
                            whiteType
                            text={t('homepage.calendar.button.detail')}
                        />
                    </TopicThirdRow>
                </>
            </Topic>
        </Item>
    );
};

export default AcademyProductTemplate;
